import { Component, Input, OnInit, AfterViewInit } from "@angular/core";
import { BaseComponent } from "../../commons/base-component/base.component";
import { HelpersService } from "../../../core/helpers/helpers.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { VodDataRestService } from "../../../data/vod/vod-data-rest.service";
import { PodcastDataRestService } from "../../../data/podcast/podcast-data-rest.service";
import { AlertService } from "../../../core/alert/alert.service";
import { BlogDataRestService } from "../../../data/blog/blog-data-rest.service";

declare var $: any;

@Component({
  selector: "app-social-share",
  templateUrl: "./social-share.component.html",
  styleUrls: ["./social-share.component.css"],
})
export class SocialShareComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  @Input() url: string;
  @Input() title: string;
  @Input() text: string;
  @Input() contentID: number;
  @Input() isPodcast: number;
  @Input() podcastID: number;
  @Input() isBlog: boolean;

  errorText: string = "no message";
  otherText: string = "";
  checker: any;
  isDesktop: boolean;

  constructor(
    helpers: HelpersService,
    private deviceService: DeviceDetectorService,
    private dataSource: VodDataRestService,
    private podcastService: PodcastDataRestService,
    private blogService: BlogDataRestService,
    private alertService: AlertService
  ) {
    super(helpers);
    this.isDesktop = deviceService.isDesktop();
  }

  ngOnInit() {
    var ua = navigator.userAgent;
    // this.url = this.url.replace("http://localhost:4210/platform", "https://www.sportstv.com.tr");
    // this.url = this.url.replace("http://localhost:4210/platform", "https://staging.atlastv.net/platform");

    // this.url = encodeURIComponent(this.url);
    console.log("URL: ", this.url);

    this.checker = {
      ios: !!ua.match(/(iPhone|iPod|iPad)/i),
      android: !!ua.match(/Android/i),
    };
  }

  ngAfterViewInit() {
    this.title = encodeURI(this.title + " | sportstv");
  }

  openDesktopShare() {
    $("#modal-social-sharing-" + this.contentID).modal("show");
  }

  share() {
    if (this.url.includes("avrupaoyunlari.sportstv.com.tr/platform")) {
      this.url = this.url.replace(
        "avrupaoyunlari.sportstv.com.tr/platform",
        "sportstv.com.tr"
      );
    }

    //https://sportstv.com.tr
    //https://sportstv.dev.atlastv.net/client
    if (this.isBlog) {
      this.url = `https://sportstv.dev.atlastv.net/client/blog/${this.podcastID}/content/${this.contentID}`;
    } else if (this.isPodcast) {
      this.url = `https://sportstv.dev.atlastv.net/client/podcastDetail/${this.podcastID}?content=${this.contentID}`;
    }

    if (this.isDesktop) {
      this.openDesktopShare();
    } else if (this.checker.ios) {
      this.openIosShare();
    } else if (this.checker.android) {
      this.openAndroidShare();
    }
  }

  openAndroidShare() {
    let mywindow: any;
    mywindow = window;
    mywindow.AndroidShareHandler.share(this.url);
  }

  openIosShare() {
    let newVariable: any;
    newVariable = window.navigator;
    if (newVariable.share) {
      newVariable.share({
        title: this.title,
        text: this.text,
        url: this.url,
      });
    }
  }

  copyText: string = "Linki kopyala";
  copyToClipboard(inputElement) {
    inputElement.select();
    document.execCommand("copy");
    inputElement.setSelectionRange(0, 0);
    this.copyText = "Link kopyalandı!";
  }

  changeCopyText() {
    this.copyText = "Linki kopyala";
  }

  likeContent() {
    if (this.isPodcast) {
      if (this.isBlog) {
        this.likePostContent();
      } else {
        this.likePodcastContent();
      }
    } else {
      this.likeVOD();
    }
  }

  dislikeContent() {
    if (this.isPodcast) {
      if (this.isBlog) {
        this.dislikePostContent();
      } else {
        this.dislikePodcastContent();
      }
    } else {
      this.dislikeVOD();
    }
  }

  likePodcastContent() {
    console.log("liked podcast: ", this.contentID);
    console.log(
      "el: ",
      document.getElementById(`like-button-${this.contentID}-${this.isPodcast}`)
    );
    this.podcastService.likePodcastContent(this.contentID).subscribe((data) => {
      if (data) {
        document.getElementById(
          `like-button-${this.contentID}-${this.isPodcast}`
        ).style.backgroundColor = "green";
        document.getElementById(
          `like-button-${this.contentID}-${this.isPodcast}`
        ).style.color = "white";
      } else {
        this.alertService.error(
          "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz."
        );
      }
    });
  }

  dislikePodcastContent() {
    console.log("disliked podcast");
    this.podcastService
      .dislikePodcastContent(this.contentID)
      .subscribe((data) => {
        if (data) {
          document.getElementById(
            `dislike-button-${this.contentID}-${this.isPodcast}`
          ).style.backgroundColor = "red";
          document.getElementById(
            `dislike-button-${this.contentID}-${this.isPodcast}`
          ).style.color = "white";
        } else {
          this.alertService.error(
            "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz."
          );
        }
      });
  }

  likePostContent() {
    this.blogService.likePostContent(this.contentID).subscribe((data) => {
      if (data) {
        let likeButtonStyle = document.getElementById(
          `like-button-${this.contentID}-${this.isPodcast}`
        ).style;
        let dislikeButtonStyle = document.getElementById(
          `dislike-button-${this.contentID}-${this.isPodcast}`
        ).style;
        if (likeButtonStyle.backgroundColor === "green") {
          likeButtonStyle.backgroundColor = null;
          likeButtonStyle.color = null;
        } else {
          likeButtonStyle.backgroundColor = "green";
          likeButtonStyle.color = "white";
          dislikeButtonStyle.backgroundColor = null;
          dislikeButtonStyle.color = null;
        }
      } else {
        this.alertService.error(
          "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz."
        );
      }
    });
  }

  dislikePostContent() {
    this.blogService.dislikePostContent(this.contentID).subscribe((data) => {
      if (data) {
        let likeButtonStyle = document.getElementById(
          `like-button-${this.contentID}-${this.isPodcast}`
        ).style;
        let dislikeButtonStyle = document.getElementById(
          `dislike-button-${this.contentID}-${this.isPodcast}`
        ).style;
        if (dislikeButtonStyle.backgroundColor === "red") {
          dislikeButtonStyle.backgroundColor = null;
          dislikeButtonStyle.color = null;
        } else {
          dislikeButtonStyle.backgroundColor = "red";
          dislikeButtonStyle.color = "white";
          likeButtonStyle.backgroundColor = null;
          likeButtonStyle.color = null;
        }
      } else {
        this.alertService.error(
          "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz."
        );
      }
    });
  }

  likeVOD() {
    this.dataSource.likeContent(this.contentID).subscribe((data) => {
      if (data) {
        document.getElementById(
          `like-button-${this.contentID}-${this.isPodcast}`
        ).style.backgroundColor = "green";
        document.getElementById(
          `like-button-${this.contentID}-${this.isPodcast}`
        ).style.color = "white";
      }
    });
  }

  dislikeVOD() {
    this.dataSource.disLikeContent(this.contentID).subscribe((data) => {
      if (data) {
        document.getElementById(
          `dislike-button-${this.contentID}-${this.isPodcast}`
        ).style.backgroundColor = "red";
        document.getElementById(
          `dislike-button-${this.contentID}-${this.isPodcast}`
        ).style.color = "white";
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/shared/widgets/social-share/social-share.component.ts